// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3qZRc","signatureButtonsRight":"ModalSign_signatureButtonsRight__1uPA4"};